import { useEffect, useState } from "react";
import { isMobile, isTablet } from "react-device-detect";

/**
 * Hook to detect if the current device is a desktop
 * Combines react-device-detect with window width detection
 * and responds to window resize events
 * 
 * @param {number} desktopThreshold - Minimum window width to consider desktop (default: 1024px)
 * @returns {boolean} true if desktop, false if mobile or tablet
 */
export const useDeviceDetection = (desktopThreshold = 1024) => {
  const [windowWidth, setWindowWidth] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth;
    }
    return desktopThreshold;
  });

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile || isTablet) {
    return false;
  }


  return windowWidth >= desktopThreshold;
};

export default useDeviceDetection;

